var joinedEventChannel = false
export default function joinAttendeePrivateChannel (eventAttendee, Echo) {
  if (joinedEventChannel) return
  console.log('joining online')
  var eventAttendeeId = eventAttendee && eventAttendee.id
  if (eventAttendeeId) {
    Echo.private(`event-attendee-active.${eventAttendeeId}`)
    joinedEventChannel = true
  }
}